module.exports = __webpack_public_path__ + "img/jnrclh.81856a2f.png";